import {Article} from "../types/article";

const API_URL = process.env.REACT_APP_API_URL;
if (!API_URL) {
    throw new Error('環境変数が設定されていません');
}

export const getArticleById = async (id: string): Promise<Article | null> => {
    const res = await fetch(`${API_URL}/posts`, {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({action: 'get', PostID: id})
    });
    if (!res.ok) return null;
    const data = await res.json();
    const item = data.item;
    if (!item) return null;

    return {
        id: item.PostID,
        title: item.Title,
        // 後方互換: 旧データではCreatedAtが無い場合があるためPublishedAtで補完
        createdAt: item.CreatedAt ?? item.PublishedAt,
        updatedAt: item.UpdatedDate ?? undefined,
        content: item.Content,
    };
};